import React, {forwardRef, useImperativeHandle} from "react";
import {Descriptions} from "antd";

const Lana = (props, ref) => {
  const { account } = props;
  const { meta } = account;

  useImperativeHandle(ref, () => null);

  return (
    <Descriptions bordered title={account.alias}>
      <Descriptions.Item label="Account ID" span={3}>
        {account.id}
      </Descriptions.Item>
      <Descriptions.Item label="CLABE" span={3}>
        {meta.account_number}
      </Descriptions.Item>
      <Descriptions.Item label="Status" span={3}>
        {meta.status}
      </Descriptions.Item>
      <Descriptions.Item label="Creation Status" span={3}>
        {meta.creation_status}
      </Descriptions.Item>
    </Descriptions>
  )
};

export default forwardRef(Lana);
